<template>
  <div class="users-list">
    <el-table
        :data="subscriberUsers"
        style="width: 100%;"
        @sort-change="sort"
        @filter-change="filterChange">


      <el-table-column  prop="subscriber_email">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Subscriber E-mail"
              :status-sort="sortBy"
              sort-key="email"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>


      <el-table-column  prop="created_at">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Created At"
              :status-sort="sortBy"
              sort-key="created_at"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>


    </el-table>
    <div class="pagin-wrp">
      <el-pagination
          :background="true"
          layout="prev, pager, next"
          :page-size="1"
          @current-change="chosePage"
          :total="subscriberMeta.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

import HeaderSortTitle from '../UsersList/HeaderSortTitle'
import {mapGetters} from "vuex";

export default {
  name: "SubscriberTableList",
  components: {
    HeaderSortTitle,
  },
  props: {
    pageLabel: String,
    filterProps: {},
    countUser: Number,
    filterUser: String,
  },
  data () {
    return {
      chosenPage: 1,
      sortBy: {
        email:0,
        created_at: 0,
      },
      filterBlock:this.filterProps,
    }
  },
  computed: {
    ...mapGetters({
      subscriberUsers: 'users/subscriberUsers',
      subscriberMeta: 'users/subscriberMeta',
      searchParams: 'users/searchParams',
      formatData: 'formatData/getFormates',
    }),
  },
  methods: {

    filterChange(filter) {
      this.filterBlock = filter
      this.$emit('updateContent',  this.filterBlock)
      this.updateSubscriberUserList()
    },
    chosePage (e) {
      this.chosenPage = e
      this.updateSubscriberUserList()
    },

    sort(by) {
      let key  = (typeof by ==="object") ? by.prop : by

      if (this.sortBy[key] === 0) {
        this.sortBy[key] = 1
      } else if (this.sortBy[key] === 1) {
        this.sortBy[key] = -1
      } else if (this.sortBy[key] === -1) {
        this.sortBy[key] = 0
      }
      if(typeof by ==="object" && by.order==null){
        this.sortBy[key] = 0
      }
      this.updateSubscriberUserList()
    },

    updateSubscriberUserList() {
      let params = 'sort='
      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params = `${params}${itm},`
          } else if (this.sortBy[itm] === -1) {
            params = `${params}-${itm},`
          }
        }
      }
      if (params === 'sort=') {
        params = ''
      }
      params = `${params}&page=${this.chosenPage}`
      if (this.countUser) {
        params = `${params}&per_page=${this.countUser}`
      }
      if (this.filterUser.length) {
        params = `${params}&filter=${this.filterUser}`
      }
      if(this.pageLabel) {
        params = `${params}`
      }
      if (typeof this.filterBlock != 'undefined' && Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length === 0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }
      this.$store.dispatch('users/getSubscriberUsers', params)
    },

  },
  created () {
    this.updateSubscriberUserList()
    if(!this.getFormates){
      this.$store.dispatch('formatData/getFormatData')
    }
    this.$store.dispatch('networks/networkGroups')
  },
  watch:{
    countUser(){
      this.updateSubscriberUserList()
    },
    filterUser(){
      this.chosenPage = 1
      this.updateSubscriberUserList()
    }
  }
}
</script>

